import * as React from "react"
import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Modal } from "@tenforce/toolbox-modal-react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import TutorialList from "./TutorialList"
import "./Tutorial.scss"
import { Labels } from "../../../../../util/Translations"
import { ITutorial } from "../../../index"
const { SearchManual, SearchManualJSON } = Labels
interface Props {
    buttonExtraClasses: string
}

interface State {
    show: boolean
    searchTutorial: ITutorial
}

export default class Tutorial extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            show: false,
            searchTutorial: JSON.parse(SearchManualJSON),
        }
    }

    render(): JSX.Element {
        const { show, searchTutorial } = this.state
        const { buttonExtraClasses } = this.props

        return (
            <>
                <Action
                    id="searchTutorial"
                    actionType={ActionType.icon}
                    title={SearchManual}
                    extraClasses={buttonExtraClasses}
                    onClick={this.showModal}
                >
                    {Symbols.Tooltip}
                </Action>
                <Modal
                    isShown={show}
                    containerProps={{
                        id: "searchTutorialModal",
                        isCenterPositioned: true,
                        onClose: this.hideModal,
                    }}
                    contentProps={{
                        extraClasses: "tw-my-1/20 tw-mx-4 sm:tw-mx-1/5",
                    }}
                >
                    <TutorialList
                        {...searchTutorial}
                        searchManual={SearchManual}
                    />
                </Modal>
            </>
        )
    }

    showModal = (): void => this.setState({ show: true })

    hideModal = (): void => this.setState({ show: false })
}
